import { isTruthy } from "@dashboard/library";

import { CallDetailsFragment } from "@/graphql/generated/graphql";
import { Call } from "@/states/call/call.utility.decl";

export function mapToNextActions(
  transcription: CallDetailsFragment["transcription"] | null
): Call["nextActions"] {
  if (!transcription || transcription.__typename === "VoicemailTranscription") {
    return undefined;
  }

  return transcription.insights?.nextActions?.actions.filter(isTruthy);
}
